import React, {useState} from 'react'
import {Button, Input, Modal, ModalBody, ModalFooter} from "reactstrap";
import MarkdownEditor from "../editor/MarkdownEditor";

import '../../assets/css/CustomInputs.css'
import {ButtonCancel} from "../buttons/buttonsActions";

const MarkdownInput = ({
    label,
    type,
    name,
    rows,
    onChange,
    placeholder,
    disabled,
    child
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [inputValue, setInputValue] = useState(child?.[name] || '');

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const onInputChange = (value) => {
        onChange(name, value, child.lang)
        setInputValue(value);
    }

    return <>
        <label>{label}</label>
        <div className="input-container">
            <Input
                type={type}
                name={name}
                rows={rows}
                value= { inputValue }
                onChange={event => onInputChange(event.target.value)}
                placeholder={placeholder}
                disabled={disabled}
            />

            <button
                type="button"
                className="input-button"
                onClick={toggleModal}>
                <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
            </button>
        </div>

        <Modal
            className={'no-padding-modal'}
            isOpen={isModalOpen}
            toggle={toggleModal}
        >
            <ModalBody>
                <MarkdownEditor
                    initialValue={inputValue}
                    onInputChance={onInputChange}
                />
                <br/>
                <div className={'float-right'}>
                    <ButtonCancel onClick={ toggleModal }/>
                </div>
            </ModalBody>
        </Modal>
    </>
}

export default MarkdownInput